window.eDaysIntegration = (function($, window, document) {

  var init = function() {
    initTestCredentials();
    initLocationSyncToggle();
  }

  var initTestCredentials = function() {
    $('#test-credentials-btn').on('click', function(e) {
      e.preventDefault();

      var btn = $(this);
      var originalText = btn.text();
      var flashMessages = $('#flash-messages');

      // Disable button and show loading state
      btn.prop('disabled', true);
      btn.text(I18n.t('admin.e_days_integration.testing'));
      flashMessages.empty();

      // Get credentials from form fields
      var credentials = {
        client_id: $('[name="integration[client_id]"]').val(),
        secret: $('[name="integration[secret]"]').val(),
        base_auth_url: $('[name="integration[base_auth_url]"]').val()
      };

      // Make AJAX request to test credentials
      $.ajax({
        url: btn.data('test-url'),
        type: 'POST',
        dataType: 'json',
        data: credentials,
        success: function(data) {
          var messageHtml;
          if (data.success) {
            messageHtml = '<div class="alert alert-success">' +
              '<a class="close" data-dismiss="alert">×</a>' +
              '<div id="flash_notice">' + data.message + '</div>' +
              '</div>';
          } else {
            messageHtml = '<div class="alert alert-error">' +
              '<a class="close" data-dismiss="alert">×</a>' +
              '<div id="flash_error">' + data.message + '</div>' +
              '</div>';
          }
          flashMessages.html(messageHtml);
        },
        error: function(xhr) {
          var errorMessage = I18n.t('admin.e_days_integration.controller.test_error_generic');

          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }

          var messageHtml = '<div class="alert alert-error">' +
            '<a class="close" data-dismiss="alert">×</a>' +
            '<div id="flash_error">' + errorMessage + '</div>' +
            '</div>';
          flashMessages.html(messageHtml);
        },
        complete: function() {
          // Re-enable button and restore original text
          btn.prop('disabled', false);
          btn.text(originalText);
        }
      });
    });
  }

  var initLocationSyncToggle = function() {
    // Handle location sync checkbox toggle
    $('#location-sync-enabled').on('change', function() {
      var isEnabled = $(this).is(':checked');
      $('#location_sync_interval').prop('disabled', !isEnabled);
    });
  }

  return {
    init: init
  };

})(jQuery, window, document);
